import React, { useState } from 'react';
import AuthErrorMessage from '../messages/AuthErrorMessage';
import AuthFormLayout from '../layouts/AuthFormLayout';
import { FloatingLabelInput } from '../common/FloatingLabelInput';
import AuthNavButton from '../common/AuthNavButton';

interface ConfirmAccountFormProps {
  email: string;
  onSubmit: (email: string, code: string) => Promise<void>;
  isLoading: boolean;
  error?: string | null;
  onSwitchToSignIn: () => void;
}

const ConfirmAccountForm: React.FC<ConfirmAccountFormProps> = ({
  email,
  onSubmit,
  isLoading,
  error,
  onSwitchToSignIn,
}) => {
  const [confirmationCode, setConfirmationCode] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    await onSubmit(email, confirmationCode);
  };

  return (
    <AuthFormLayout
      title="Confirm Account"
      footer={
        <div className="mt-4 text-center">
          <AuthNavButton onClick={onSwitchToSignIn}>Back to sign in</AuthNavButton>
        </div>
      }
      onSubmit={handleSubmit}
    >
      <AuthErrorMessage error={error} />
      <div>
        <FloatingLabelInput
          label="Confirmation Code"
          type="text"
          value={confirmationCode}
          onChange={e => setConfirmationCode(e.target.value)}
          required
        />
        <p className="mt-2 text-sm text-gray-600 dark:text-neutral-300">
          Please check your email ({email}) for the confirmation code.
        </p>
        <button
          type="submit"
          disabled={isLoading}
          className="mt-4 w-full rounded-md border border-gray-300 bg-gray-200 px-4 py-2 text-sm font-medium text-gray-900 shadow-sm hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-neutral-500 focus:ring-offset-2 disabled:opacity-50 dark:border-neutral-800 dark:bg-neutral-900 dark:text-white dark:hover:bg-neutral-800"
        >
          {isLoading ? 'Confirming...' : 'Confirm Account'}
        </button>
      </div>
    </AuthFormLayout>
  );
};

export default ConfirmAccountForm;
